import {
  GET_ITEM_LIST_DATA,
  GET_ITEM_DATA,
  RESET_ITEM_DATA,
  SET_ITEM_STATUS,
  SET_LIST_STATUS,
  GET_MATERIAL_GROUP_TABLE_DATA,
  SET_MATERIAL_GROUP_TABLE_STATUS,
  SAVE_ITEM_LIST_DATA,
  RESET_ITEM_TABLE_LIST_DATA,
} from '../helpers/types';

const INITIAL_STATE = {
  itemList: [],
  itemTableList: [],
  selItem: null,
  selItemData: undefined,
  isItemLoading: false,
  isLoading: false,
  materialGroupDataArr: [],
  listCount: null,
  top: 20,
  isMaterialLoading: false,
  failText: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_ITEM_DATA:
      return { ...state, selItem: null, selItemData: null };
    case GET_ITEM_LIST_DATA:
      return {
        ...state,
        [action.payload.field]: action.payload.itemList,
        isLoading: false,
        listCount: action.payload.listCount,
        failText: action.payload.failText,
      };
    case RESET_ITEM_TABLE_LIST_DATA:
      return {
        ...state,
        itemTableList: [],
        listCount: null,
      };
    case SAVE_ITEM_LIST_DATA:
      return {
        ...state,
        itemList: action.payload.itemList,
        // listCount: action.payload.itemList.length,
        failText: '',
      };
    case GET_ITEM_DATA:
      return { ...state, ...action.payload };
    case SET_ITEM_STATUS:
      return {
        ...state,
        isItemLoading: action.payload.isItemLoading,
      };
    case SET_LIST_STATUS:
      return {
        ...state,
        ...action.payload,
      };
    case GET_MATERIAL_GROUP_TABLE_DATA:
      return {
        ...state,
        materialGroupDataArr: action.payload.data,
        isMaterialLoading: false,
      };
    case SET_MATERIAL_GROUP_TABLE_STATUS:
      return {
        ...state,
        isMaterialLoading: action.payload.isMaterialLoading,
      };
    default:
      return state;
  }
};
